import { initNewsletterForm } from "@/scripts/sections/newsletter-form-handler"

document.querySelectorAll("form[data-newsletter-form]").forEach((form) => {
  initNewsletterForm(form)
})
